import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus, faSearchMinus, faUndo } from "@fortawesome/free-solid-svg-icons";

function ImagePreviewModalWithZoom({ open, image, onClose }) {
    const [scale, setScale] = useState(0.35);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [start, setStart] = useState({ x: 0, y: 0 });

    if (!open) return null;

    const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.25, 5));
    const handleZoomOut = () => setScale((prev) => Math.max(prev - 0.25, 0.35));
    const handleReset = () => {
        setScale(0.35);
        setPosition({ x: 0, y: 0 });
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        setPosition({
            x: e.clientX - start.x,
            y: e.clientY - start.y,
        });
    };

    const handleMouseUp = () => setIsDragging(false);

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 mt-28"
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
        >
            <div className="bg-white p-4 rounded-md lg:w-[80vw] max-h-[90vh] overflow-auto">
                <div
                    className="relative max-h-[60vh] overflow-hidden flex justify-center items-center cursor-grab active:cursor-grabbing"
                    onMouseDown={handleMouseDown}
                >
                    <img
                        src={image}
                        alt="Enlarged view"
                        style={{
                            transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                            transition: isDragging ? "none" : "transform 0.3s ease",
                        }}
                        className="object-contain select-none pointer-events-none"
                    />
                </div>
                <div className="flex gap-2 mt-3 justify-center">
                    <button
                        onClick={handleZoomOut}
                        className="px-3 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                    >
                        <FontAwesomeIcon icon={faSearchMinus} />
                    </button>
                    <button
                        onClick={handleZoomIn}
                        className="px-3 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                    >
                        <FontAwesomeIcon icon={faSearchPlus} />
                    </button>
                    <button
                        onClick={handleReset}
                        className="px-3 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                    >
                        <FontAwesomeIcon icon={faUndo} />
                    </button>
                </div>

                {/* Close button */}
                <button
                    onClick={onClose}
                    className="mt-3 w-full px-4 py-2 bg-gray-300 hover:bg-gray-400 text-black rounded-md transition-colors"
                >
                    Close
                </button>
            </div>
        </div>
    );
}

export default ImagePreviewModalWithZoom;